import React from 'react';
import styled from 'styled-components';

interface ProgressBarProps {
    max: number;
    value: number | undefined;
    $isErrorStyle?: boolean;
}

interface ProgressBarContainerProps {
    $isErrorStyle?: boolean;
}

interface FillerProps {
    $isErrorStyle?: boolean;
    width: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ max, value = 0, $isErrorStyle = false }) => {
    const percentage = (value / max) * 100;
    return (
        <ProgressBarContainer $isErrorStyle={$isErrorStyle}>
            <Filler $isErrorStyle={$isErrorStyle} width={`${percentage > 100 ? 100 : percentage}%`} />
        </ProgressBarContainer>
    );
};

const ProgressBarContainer = styled.div<ProgressBarContainerProps>`
    height: 10px;
    width: 100%;
    background-color: ${({ $isErrorStyle, theme }) =>
        $isErrorStyle ? theme.colors.lightRed + '1A' : theme.colors.culturedGrey}; // 1A for opacity
    border-radius: 50px;
`;

const Filler = styled.div<FillerProps>`
    height: 100%;
    width: ${({ width }) => width};
    transition: width 1s ease-in-out;
    background-color: ${({ $isErrorStyle, theme }) => ($isErrorStyle ? theme.colors.lightRed : theme.colors.green)};
    border-radius: inherit;
`;
